import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

const ShowOnlyPendingRequestsCheckbox = ({
    showOnlyPendingRequestsHandler = () => { },
    checked,
    label = "Show only approval pending",
    styles = { marginTop: '-20px' }
}) => {

    return (
        <FormControlLabel
            sx={styles}
            control={
                <Checkbox
                    onChange={(e) => showOnlyPendingRequestsHandler(e.target.checked)}
                    checked={checked}
                // sx={checkBoxStyle}
                />
            }
            label={
                <span style={{ fontSize: '14px' }}>
                    {label}
                </span>
            }
        />
    );
}

export default ShowOnlyPendingRequestsCheckbox;